import React from "react";
import { Container } from "react-bootstrap";
import "./CSR.css";

const CSR = () => {
  return (
    <section className="csr-page">
      <Container>

        <h1 className="csr-heading">
          Corporate Social Responsibility (CSR) & Responsible Tourism
        </h1>

        <h2 className="csr-subheading">Travel as a Force for Good</h2>

        <p>
          At Plenary Holidays, we believe that travel should be a force for positive economic, social, and environmental impact.
        </p>

        <p>
          While we are a professionally growing organization, our commitment to responsible tourism is integrated into the way we conduct business, manage corporate programs, and curate leisure tours.
        </p>

        <p>
          For over 16 years, our focus has remained on transparency, ethical growth, and minimizing the footprint of our travel operations.
        </p>

        <hr />

        <h3>1. Supporting Local Communities</h3>

        <p>
          Our primary CSR philosophy is rooted in Economic Inclusion.
        </p>

        <p>
          Instead of relying solely on global chains, we actively prioritize regional participation and community engagement in the destinations where we operate.
        </p>

        <h4>Local Employment</h4>

        <p>
          We work closely with local guides, drivers, and ground staff across regions such as Sikkim, Himachal Pradesh, Rajasthan, and other key Indian destinations.
        </p>

        <p>
          By strengthening local partnerships, we ensure that the economic benefits of tourism remain within the community.
        </p>

        <h4>Promoting Local Artisans</h4>

        <p>
          On our curated tours, we encourage travelers to visit local craft centers, regional markets, and heritage clusters. This supports traditional livelihoods and promotes indigenous craftsmanship.
        </p>

        <hr />

        <h3>2. Ethical Business & Compliance</h3>

        <p>
          We believe responsible tourism begins with responsible corporate conduct.
        </p>

        <h4>Fair Trade Practices</h4>

        <p>
          We maintain fair vendor agreements and ensure timely payments to our small-scale partners, transport providers, and destination service vendors.
        </p>

        <h4>Transparency & Governance</h4>

        <p>
          Our operations follow a documented, GST-compliant framework with clear inclusions, exclusions, and no hidden costs.
        </p>

        <p>
          As registered members of recognized industry bodies, we adhere to structured professional standards in all our engagements.
        </p>

        <hr />

        <h3>3. Environmental Consciousness in MICE & Travel</h3>

        <p>
          As we expand our MICE and Corporate Travel operations, we actively encourage environmentally responsible practices.
        </p>

        <h4>Digital Transformation</h4>

        <p>
          We have transitioned to fully digital itineraries, vouchers, confirmations, and invoicing—reducing reliance on paper-based documentation and outdated communication methods.
        </p>

        <h4>Responsible Venue Selection</h4>

        <p>
          Wherever possible, we recommend hotels and venues that implement:
        </p>

        <ul>
          <li>Waste management practices</li>
          <li>Energy-efficient systems</li>
          <li>Sustainable sourcing policies</li>
        </ul>

        <p>
          We also encourage corporate clients to adopt eco-conscious event formats wherever feasible.
        </p>

        <hr />

        <h3>4. Supporting Education & Awareness</h3>

        <p>
          We occasionally extend support to local educational initiatives and environmental awareness activities, particularly in sensitive Himalayan regions where we operate.
        </p>

        <p>
          Equally important, we educate our travelers on:
        </p>

        <ul>
          <li>Respecting local cultures and customs</li>
          <li>Preserving mountain ecosystems</li>
          <li>Practicing responsible travel behavior</li>
        </ul>

        <p>
          We believe informed travelers contribute to the long-term sustainability of destinations.
        </p>

        <hr />

        <h3>Our Ongoing Commitment</h3>

        <p>
          We may not operate large-scale charitable foundations, but we remain committed to:
        </p>

        <ul>
          <li>Ethical and transparent business practices</li>
          <li>Community-driven tourism growth</li>
          <li>Environmentally conscious travel planning</li>
          <li>Continuous improvement in responsible tourism standards</li>
        </ul>

        <p>
          As Plenary Holidays grows, we aim to expand structured CSR initiatives aligned with sustainable tourism and community development.
        </p>

      </Container>
    </section>
  );
};

export default CSR;